import { render, staticRenderFns } from "./SerialAppointmentDialog.vue?vue&type=template&id=ee8767d0&"
import script from "./SerialAppointmentDialog.vue?vue&type=script&lang=js&"
export * from "./SerialAppointmentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports